import DatabaseModel from './DatabaseModel.js';

var CentroTrabajo = Object.create(DatabaseModel);

CentroTrabajo.model = 'centrotrabajo';
CentroTrabajo.modelFront = 'centrostrabajo';

export default CentroTrabajo;